export const enum UIReducerActionType {
  SHOW_DETAIL = 'SHOW_DETAIL',
  SHOW_FUNCTION = 'SHOW_FUNCTION',
}

export interface UIReducerAction {
  type: UIReducerActionType;
  payload: boolean
}

export const uiReducer = (state: any, action: UIReducerAction) => {
  const { type, payload } = action;
  switch(type) {
  case UIReducerActionType.SHOW_DETAIL:
    return { ...state, showDeviceDetail: payload };
  case UIReducerActionType.SHOW_FUNCTION:
    return { ...state, showDeviceFunction: payload };
  default:
    return state;
  }
};
